import { Center, Spinner, Stack, Text } from '@chakra-ui/react';

export const PageSpinner = ({ label }: { label?: string }) => {
    return (
        <Center flex={1}>
            <Stack alignItems="center">
                <Spinner size="xl" />
                {label && <Text>{label}</Text>}
            </Stack>
        </Center>
    );
};
